<template>
    <div>
        <div class="file clearfix" :class="[fileSize]">
            <img
                v-if="fileItem && fileItem.url"
                :src="fileItem.url"
                class="icon-img"
                alt="file-img"
            />
            <div v-else-if="fileItem">
                <img :src="getFileItem()" class="icon-img" alt="file-img" />
            </div>

            <i v-else class="file__icon">
                <GifIcon v-if="getIcon(name, type) == 'gif'" />
                <JpgIcon v-if="getIcon(name, type) == 'jpg'" />
                <PdfIcon v-if="getIcon(name, type) == 'pdf'" />
                <SvgIcon v-if="getIcon(name, type) == 'svg'" />
                <BinIcon v-if="getIcon(name, type) == 'bin'" />
                <PngIcon v-if="getIcon(name, type) == 'png'" />
            </i>

            <div class="file__name" :title="name.toLowerCase()">
                {{ croppFileName(name, 30, type).toLowerCase() }}
            </div>

            <button
                class="file__delete icon-delete button"
                @click.prevent.stop="removeFile()"
            >
                <TrashIcon />
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { croppFileName } from '@/lib/croppName';

//SVGs
import TrashIcon from 'Svgs/trash.svg?inline';
import BinIcon from 'Svgs/fileicons-bin.svg?inline';
import GifIcon from 'Svgs/fileicons-gif.svg?inline';
import JpgIcon from 'Svgs/fileicons-jpg.svg?inline';
import PdfIcon from 'Svgs/fileicons-pdf.svg?inline';
import SvgIcon from 'Svgs/fileicons-svg.svg?inline';
import PngIcon from 'Svgs/fileicons-png.svg?inline';

export default {
    components: {
        TrashIcon,
        BinIcon,
        GifIcon,
        JpgIcon,
        PdfIcon,
        SvgIcon,
        PngIcon,
    },
    props: {
        screenshot: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
            required: true,
        },
        type: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: '',
        },
        fileItem: {
            type: Object,
            dafault: () => null,
        },
    },
    computed: {
        ...mapGetters('settings', {
            webpSupports: 'webp',
        }),
        fileSize() {
            return this.size ? `file--${this.size}` : '';
        },
    },
    methods: {
        getFileItem() {
            if (this.fileItem.data && this.fileItem.data.type === 'video') {
                return this.fileItem.data.name;
            } else if (this.fileItem.file_id) {
                const type = this.webpSuppport ? 'webp' : 'jpg';

                return `/api/images/${this.fileItem.file_id}?width=240&type=${type}`;
            } else if (this.fileItem.data.formData) {
                const file = this.fileItem.data.formData.get('file');
                const url = URL.createObjectURL(file);
                return url;
            }

            if (this.webpSuppport) {
                return require('Images/asset_thumb_placeholder.webp');
            } 
            return require('Images/asset_thumb_placeholder.jpg');
        
        },
        getIcon(name, fileType) {
            if (fileType && fileType === 'video') {
                return 'file-ytb';
            }
            const types = 'png, jpg, svg, pdf, gif, ycp';
            const nameArr = name.split('.');
            const type = nameArr[nameArr.length - 1].toLowerCase();
            return types.indexOf(type) >= 0 ? `${type}` : '';
        },
        croppFileName,
        removeFile() {
            this.$emit('removed');
        },
    },
};
</script>

<style lang="scss" scoped>
.icon-img {
    object-fit: cover;
    height: 60px;
    width: 60px;
}
.icon-delete {
    svg {
        fill: $yellow-main;
        width: em(26);
        height: em(26);
    }
}
</style>
